// 1st child component
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { FormlyConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { UserService } from '../../../../Service/User/user.service';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';
import { ServiceAdvisorFormStateService } from '../../service/service-advisor-formStateService';
import { Subscription } from 'rxjs';
import { CustomDateTypeComponent } from '../../../../Formly/custom-types/custom-datepicker-min.type';

@Component({
  selector: 'app-add-service-advisor-details',
  templateUrl: './add-service-advisor-details.component.html',
  styleUrl: './add-service-advisor-details.component.scss',
})
export class AddServiceAdvisorDetailsComponent implements OnInit, OnDestroy {
  serviceAdvisorId: any;
  form = new FormGroup({});
  // model: any = {};
  model: any = {
    serviceAdvisorId: '',
    name: '',
    email: '',
    phone: '',
    dob: '',
    professionalExperience: '',
    qualification: '',
    bio: '',
    stateId: '',
    countryId: '',
    districtId: '',
    city: '',
    zip: '',
    address: '',
  };
  fields: FormlyFieldConfig[] = [];
  countryId: any;
  countryName!: string;
  @Output() nextSection = new EventEmitter<void>();
  @Output() formValidity = new EventEmitter<boolean>();
  private subscription: Subscription | undefined;
  @Input() receivedObject: any;
  @Input() editMode!: boolean;
  stateId: any;
  constructor(
    private api: ServiceProviderService,
    private userService: UserService,
    private formStateService: ServiceAdvisorFormStateService,
    private cdr: ChangeDetectorRef,
    private formlyConfig: FormlyConfig
  ) { }

  ngOnInit(): void {
    this.loadFormData();
    const userDetailsString = localStorage.getItem('user');
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      this.countryId = userDetails.country?.countryId;
      const storedCountryName = userDetails.country?.name;
      if (this.countryId) {
        this.model.countryId = this.countryId;
        this.form.patchValue({ countryId: this.countryId });
        this.initializeField();
      }
    }
    if (this.receivedObject) {
      this.populateFormWithServiceProviderDetails(this.receivedObject);
    }

    // Listen for changes and save to the form state service
    this.form.valueChanges.subscribe((formData) => {
      this.saveFormData();
    });

    // Initialize form fields
    this.initializeField();
    if (!this.formlyConfig.getType('custom-min-dt')) {
      this.formlyConfig.setType({
        name: 'custom-min-dt',
        component: CustomDateTypeComponent,
      });
    }
  }


  resetForm() {
    this.form.reset();
    this.model = {};
  }

  initializeField() {
    this.fields = [
      {
        template: '<div class="text-base font-semibold mb-4">Basics</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-5',
            key: 'name',
            type: 'input',
            templateOptions: {
              label: 'Name of the Service Advisor',
              placeholder: 'Enter Name',
              required: true,
              hideRequiredMarker: true,
              pattern: '^[a-zA-Z][a-zA-Z\\s\\-\\.]*$',
            },
            validators: {
              validation: [Validators.required, Validators.minLength(3)],
            },
            validation: {
              messages: {
                required: 'Name is required',
                minlength: 'Name should be at least 3 characters long',
                pattern: 'Name must contain only letters and spaces',
              },
            },
            modelOptions: {
              updateOn: 'change'
            }
          },
          {
            className: 'field col-5',
            key: 'email',
            type: 'input',
            templateOptions: {
              label: 'Email',
              placeholder: 'Enter Email Address',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              email: {
                expression: (c: AbstractControl) =>
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                    c.value
                  ),
                message: (error: any, field: FormlyFieldConfig) =>
                  `${field.formControl?.value} is not a valid Email Address`,
              },
            },
          },
          {
            className: 'field col-5',
            key: 'phone',
            type: 'input',
            templateOptions: {
              label: 'Phone Number',
              placeholder: '+91 1234567890',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              validation: [Validators.required, Validators.pattern(/^\d{10}$/)],
            },
            validation: {
              messages: {
                required: 'Phone number is required',
                pattern: 'Phone number must be exactly 10 digits',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'dob',
            type: 'custom-min-dt',
            templateOptions: {
              label: 'Date of Birth',
              placeholder: 'dd/mm/yyyy',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Date of birth is required',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'professionalExperience',
            type: 'textarea',
            templateOptions: {
              label: 'Professional Exp.',
              placeholder: 'Mention your work experience here',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Professional experience is required',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'qualification',
            type: 'textarea',
            templateOptions: {
              label: 'Qualification',
              placeholder: 'Mention your Highest Achieved Qualification',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Please mention your qualification',
              },
            },
          },
        ],
      },

      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-10',
            key: 'bio',
            type: 'textarea',
            templateOptions: {
              label: 'Describe your strengths',
              placeholder: 'Enter a Description',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              validation: [Validators.required, Validators.minLength(10)],
            },
            validation: {
              messages: {
                required: 'Please mention something about your strengths',
                minlength: 'Name should be at least 10 characters long',
              },
            },
          },
        ],
      },

      {
        template:
          '<div class="text-base font-semibold mb-4 mt-5">Address</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-4',
            key: 'countryId',
            type: 'select',
            templateOptions: {
              disabled: true,
              options: this.api.getCountry(''),
              valueProp: 'countryId',
              labelProp: 'name',
              label: 'Country',
              hideRequiredMarker: true,
            },
            hooks: {
              onInit: (field) => {
                if (this.countryId) {
                  field.formControl?.setValue(this.countryId);
                  field.templateOptions!.disabled = true;
                }
              },
            },
          },
          {
            className: 'field col-3',
            key: 'stateId',
            type: 'select',
            templateOptions: {
              placeholder: 'Select State',
              options: [],
              valueProp: 'stateId',
              labelProp: 'name',
              label: 'State',
              required: true,
              hideRequiredMarker: true,
            },
            hooks: {
              onInit: (field) => {
                // Fetch states when initializing
                this.api.getStatesByCountry(this.countryId).subscribe(states => {
                  field.templateOptions!.options = states;
                });

                // Set a listener for value changes
                field.formControl?.valueChanges.subscribe((selectedStateId: number) => {
                  this.stateId = selectedStateId;

                  // Now fetch districts using selected stateId
                  const districtField = this.findFieldByKey(this.fields, 'districtId');
                  if (districtField) {
                    this.api.getDistrictsByStates(selectedStateId).subscribe(districts => {
                      districtField.templateOptions!.options = districts;
                      this.cdr.markForCheck();
                    });
                  }
                });
              }
            }
          },
          {
            className: 'field col-3',
            key: 'city',
            type: 'input',
            templateOptions: {
              label: 'City',
              placeholder: 'Select City',
              required: true,
              hideRequiredMarker: true,
            },
          },
          {
            className: 'field col-5 mt-3',
            key: 'address',
            type: 'input',
            templateOptions: {
              label: 'Address',
              placeholder: 'Enter Address',
              required: true,
              hideRequiredMarker: true,
              disabled: true,
            },
          },
          {
            className: 'field col-5 mt-3',
            key: 'zip',
            type: 'input',
            templateOptions: {
              label: 'Pincode',
              placeholder: 'Enter Pincode',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              validation: [Validators.required, Validators.pattern(/^\d{6}$/)],
            },
            validation: {
              messages: {
                required: 'Pincode is required',
                pattern: 'Pincode must be exactly 6 digits',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'districtId',
            type: 'select',
            templateOptions: {
              placeholder: 'Select district',
              options: [], // Leave empty initially
              valueProp: 'districtId',
              labelProp: 'name',
              label: 'District',
              required: true,
              hideRequiredMarker: true,
            },
          }
        ],
      },
    ];
  }
  findFieldByKey(
    fields: FormlyFieldConfig[],
    key: string
  ): FormlyFieldConfig | null {
    for (const field of fields) {
      if (field.key === key) {
        return field;
      }
      if (field.fieldGroup && field.fieldGroup.length > 0) {
        const nestedField = this.findFieldByKey(
          field.fieldGroup as FormlyFieldConfig[],
          key
        );
        if (nestedField) {
          return nestedField;
        }
      }
    }
    return null;
  }
  ngOnDestroy() {
    this.saveFormData();
  }

  saveFormData() {
    const formData = { ...this.form.value };
    this.formStateService.setFormData('service-advisor-details', formData);
    console.log(formData);
  }

  loadFormData() {
    const savedData = this.formStateService.getFormData(
      'service-advisor-details'
    );
    if (savedData) {
      console.log('Saved Data:', savedData);
      this.model = savedData;
      this.form.patchValue(savedData);
    }
    const mapLocationData = this.formStateService.getFormData('map-location');
  if (mapLocationData?.address) {
    this.model.address = mapLocationData.address;
    this.form.patchValue({ address: mapLocationData.address });
  }
  }

  onSubmit() {
    if (this.form.valid) {
      const transformedData = this.transformFormData(this.form.value);
      this.formStateService.setServiceAdvisorDetails(transformedData);
      console.log(transformedData);
      this.nextSection.emit();
    }
  }

  transformFormData(formData: any): any {
    const mapLocationData = this.formStateService.getFormData('map-location');
    const address = formData.address || mapLocationData?.address || '';

    const transformedData: any = {
      name: formData.name,
      phoneNumber: formData.phone,
      emailAddress: formData.email,
      bio: formData.bio,
      address: address,
      stateId: formData.stateId,
      countryId: this.countryId,
      city: formData.city,
      zip: formData.zip,
      dob: new Date(formData.dob).toISOString(),
      professionalExperience: formData.professionalExperience,
      qualification: formData.qualification,
      districtId: formData.districtId
    };

    // will be included if the serviceAdvisorId exists
    if (this.serviceAdvisorId) {
      transformedData.serviceAdvisorId = this.serviceAdvisorId;
    }

    return transformedData;
  }
  populateFormWithServiceProviderDetails(res: any) {
    this.serviceAdvisorId = res.serviceAdvisorId;
    console.log('Advisor id', this.serviceAdvisorId);

    const formattedDob = res.dob
      ? this.formatDateToMMDDYYYY(new Date(res.dob))
      : '';

    const stateId = res.state?.stateId;
    const districtId = res.district?.districtId;


    const mapLocationData = this.formStateService.getFormData('map-location');
  const address = mapLocationData?.address || res.address || '';
    // Patch everything except districtId
    this.model = {
      serviceAdvisorId: res.serviceAdvisorId || '',
      name: res.name || '',
      phone: res.phoneNumber || '',
      email: res.emailAddress || '',
      bio: res.bio || '',
      address: address,
      stateId: stateId || '',
      countryId: res.country?.countryId || '',
      zip: res.zip || '',
      qualification: res.qualification || '',
      professionalExperience: res.professionalExperience || '',
      dob: formattedDob,
      city: res.city || '',
      districtId: '' // delay patching this one
    };

    this.initializeField(); // this ensures fields are ready
    this.form.patchValue(this.model);

    if (stateId) {
      this.api.getDistrictsByStates(stateId).subscribe((districts) => {
        const districtField = this.findFieldByKey(this.fields, 'districtId');
        if (districtField) {
          districtField.templateOptions!.options = districts;

          // Now patch the districtId after options are loaded
          this.model.districtId = districtId;
          this.form.patchValue({ districtId });
          this.cdr.markForCheck();
        }
      });
    }

    this.formStateService.setFormData('service-advisor-details', this.model);
    this.cdr.detectChanges();
  }

  formatDateToMMDDYYYY(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
}
